export const route = {
    game :  'game',
    registration : 'registration',
    pointAccrual: 'point-accrual',
    auth : 'auth',
    leads : 'leads',
    helpDesk : 'helpdesk',
    productCatalog : 'product-catalog',
    cart : 'cart',
    pointRedemption : 'point-redemption',
    notification : 'notification'
}

